module.exports = __webpack_public_path__ + "fonts/dxicons.71e4862e.woff2";